import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-icon-restore',
  templateUrl: './btn-icon-restore.component.html',
  styleUrls: ['./btn-icon-restore.component.css']
})
export class BtnIconRestoreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
